export const SECTOR_ANALYTICS_EVENTS = {
  SECTOR_STATS_FETCHED: "sector-stats-fetched",
  SECTOR_PRODUCTIVIY_FETCHED: "sector-productivity-fetched",
};
